<template>
  <div class="w-full flex flex-col items-center">
    <div class="pt-24">
      <EmptyResultsSVG />
    </div>
    <div class="pt-8 text-center main--content pb-32">
      <p class="text-zt-primary-200 text-zt-base leading-tight">
        {{ $t("message.inicioComponent.notResults") }}
      </p>
      <p class="pt-2 text-zt-md text-zt-dark-300">
        {{ $t("message.inicioComponent.infoSearch") }}
      </p>
    </div>
  </div>
</template>

<script>
import EmptyResultsSVG from './SVG/EmptyResults'
export default {
  name: 'SearchEmptyResults',
  components: {
    EmptyResultsSVG
  }
}
</script>

<style scoped>
.main--content {
  max-width: 450px;
}
</style>
